import { render, staticRenderFns } from "./vendor-details-summary.vue?vue&type=template&id=72dd7e82&scoped=true"
import script from "./vendor-details-summary.vue?vue&type=script&lang=js"
export * from "./vendor-details-summary.vue?vue&type=script&lang=js"
import style0 from "./vendor-details-summary.vue?vue&type=style&index=0&id=72dd7e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd7e82",
  null
  
)

export default component.exports